const getLocalVehicles = electricVehicles => {
  return electricVehicles.filter(ev => ev.locally_available);
};

export default getLocalVehicles;
